module.exports = __webpack_public_path__ + "static/img/抗氧剂.eb54d64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/抗氧剂.jpg
// module id = 190
// module chunks = 1